import axios from "axios";

import { getHeader } from "../headers";

// ===================================================================================
//  GET PROFILE STATUSES
// ===================================================================================
export const profileStatusesLoading = () => {
	return {
		type: "PROFILE_STATUSES_IS_LOADING"
	};
};

export const profileStatusesError = err => {
	return {
		type: "PROFILE_STATUSES_HAS_ERROR",
		err
	};
};

export const profileStatusesSuccess = data => {
	return {
		type: "PROFILE_STATUSES_SUCCESS",
		data
	};
};

export function getProfileStatuses() {
	return dispatch => {
		dispatch(profileStatusesLoading());

		return axios
			.get(process.env.REACT_APP_API_URL + "profile-statuses", {
				headers: getHeader()
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					dispatch(profileStatusesError(response.data.errors));
				} else {
					dispatch(profileStatusesSuccess(response.data));
					return Promise.resolve(response);
				}
			})
			.catch(err => {
				dispatch(profileStatusesError(err.response.data.message));
			});
	};
}



// WEBPACK FOOTER //
// ./src/store/actions/profileStatuses.js